import { createAsyncThunk } from "@reduxjs/toolkit";
import { fetchChannelModAllData, fetchTrendDataByChannelNos } from "../../api/channel";
import { fetchCharts } from "../../api/charts";
import dayjs from "dayjs";

export const fetchChannelLatestDataForDashboard = createAsyncThunk('dashboard/channelLatestData', async ({ vesselId }) => {
  const { channelData } = await fetchChannelModAllData(vesselId);
  return channelData;
})

export const fetchChartsInfoForDashboards = createAsyncThunk('dashboard/charts', async ({ vesselId }) => {
  const { charts } = await fetchCharts(vesselId);
  return charts;
})

export const fetchLiveTrendDataForDashboard = createAsyncThunk('dashboard/liveTrendData', async ({ vesselId, channelNos, chartId }, {signal}) => {
  if(channelNos.length === 0) return;
  const interval = 0
  const startDate = dayjs.utc().subtract(60, 'm').startOf('s');
  const endDate = dayjs.utc().subtract(1, 'm').startOf('s');
  const convertChNosToStr = channelNos.join(',');
  const data = await fetchTrendDataByChannelNos(vesselId, convertChNosToStr, startDate, endDate, interval, signal);
  return { id: chartId, data: data.trendData };
})

export const fetchLiveTrendLatestDataForDashboard = createAsyncThunk('dashboard/liveTrendLatestData', async ({ vesselId, channelNos, chartId }, {signal}) => {
  if(channelNos.length === 0) return;  
  const convertChNosToStr = channelNos.join(',');
  const startDate = dayjs.utc().subtract(1, 'm').startOf('s');
  const endDate = dayjs.utc().subtract(1, 'm').startOf('s');
  const data = await fetchTrendDataByChannelNos(vesselId, convertChNosToStr, startDate, endDate, 0, signal);
  return { id: chartId, data: data.trendData };
})

export const fulfilledFetchChannelLatestDataForDashboard = (state, action) => {
  state.channelLatestDataForDashboard = action.payload;
}

export const fulfilledFetchChartsInfoForDashboards = (state, action) => {
  state.charts = action.payload;
}

export const fulfilledFetchLiveTrendDataForDashboard = (state, action) => {
  state.dashboardLiveTrendData = {
    ...state.dashboardLiveTrendData,
    [action.payload.id]: action.payload.data,
  }
  state.isDashboardLiveTrendFetching = {
    ...state.isDashboardLiveTrendFetching,
    [action.payload.id]: false,
  }
}

export const fulfilledFetchLiveTrendLatestDataForDashboard = (state, action) => {
  state.dashboardLiveTrendLatestData = {
    ...state.dashboardLiveTrendLatestData,
    [action.payload.id]: action.payload.data,
  }
}

export const pendingFetchLiveTrendDataForDashboard = (state, action) => {
  state.selectedDashboardLiveTrendData = []
}

export const pendingFetchLiveTrendLatestDataForDashboard = (state, action) => {
  state.dashboardLiveTrendLatestData = [];
}

export const rejectedFetchLiveTrendDataForDashboard = (state, action) => {
  state.selectedDashboardLiveTrendData = [];
}

export const rejectedFetchLiveTrendLatestDataForDashboard = (state, action) => {
  state.dashboardLiveTrendLatestData = [];
}